const services = [
    {
        title: "UI/UX Design",
        description:
          "We create intuitive, user-centric designs that transform ideas into exceptional digital experiences. Our designs focus on usability, accessibility, and seamless interaction to deliver engaging interfaces that resonate with users.",
        offerings: [
          "Wireframing & Prototyping",
          "User Journey Mapping",
          "Mobile & Web App Design",
          "Usability Testing",
        ],
        whyChooseUs: [
          "Tailored designs that meet user expectations",
          "Aesthetic and functional interface solutions",
        ],
      },
      {
        title: "UI/UX Design",
        description:
          "We create intuitive, user-centric designs that transform ideas into exceptional digital experiences. Our designs focus on usability, accessibility, and seamless interaction to deliver engaging interfaces that resonate with users.",
        offerings: [
          "Wireframing & Prototyping",
          "User Journey Mapping",
          "Mobile & Web App Design",
          "Usability Testing",
        ],
        whyChooseUs: [
          "Tailored designs that meet user expectations",
          "Aesthetic and functional interface solutions",
        ],
      },
      {
        title: "UI/UX Design",
        description:
          "We create intuitive, user-centric designs that transform ideas into exceptional digital experiences. Our designs focus on usability, accessibility, and seamless interaction to deliver engaging interfaces that resonate with users.",
        offerings: [
          "Wireframing & Prototyping",
          "User Journey Mapping",
          "Mobile & Web App Design",
          "Usability Testing",
        ],
        whyChooseUs: [
          "Tailored designs that meet user expectations",
          "Aesthetic and functional interface solutions",
        ],
      },
      {
        title: "UI/UX Design",
        description:
          "We create intuitive, user-centric designs that transform ideas into exceptional digital experiences. Our designs focus on usability, accessibility, and seamless interaction to deliver engaging interfaces that resonate with users.",
        offerings: [
          "Wireframing & Prototyping",
          "User Journey Mapping",
          "Mobile & Web App Design",
          "Usability Testing",
        ],
        whyChooseUs: [
          "Tailored designs that meet user expectations",
          "Aesthetic and functional interface solutions",
        ],
      },
  ];

  export {services}